import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity'
import { EntityAttributeResponse } from './model'

export interface State extends EntityState<EntityAttributeResponse> {
  isLoaded: boolean
  isSaving: boolean
}

export const adapter: EntityAdapter<EntityAttributeResponse> = createEntityAdapter<EntityAttributeResponse>({
  sortComparer: false,
  selectId: (attr: EntityAttributeResponse) => attr.pkey,
})

export const initialState: State = adapter.getInitialState({
  isLoaded: false,
  isSaving: false,
})
